<template>
  <modalGeneric
    class="containerHighLightModalGeneric"
    title="Highlight"
    @closeModal="close">
    <section class="containerHighLightModalGeneric__content" v-if="dataLoaded">
      <section class="containerHighLightModalGeneric__content--people" v-if="highLightObject.type === 'PeopleHighlight'">
        <div class="background">
          <img class="backgroundImage" src="../../../assets/people_highlight_modal_background.png" />
          <span class="grey-icon-grey-logo-black logo"></span>
        </div>
        <div class="peopleProfile">
          <img class="peopleProfile__image" :src="highLightObject.croppedImageUrl" />
          <div class="peopleProfile__information">
            <span class="peopleProfile__information--title" v-if="isHighLightModalMobile" style="-webkit-box-orient: vertical;">{{`${highLightObject.topLine} ${highLightObject.bottomLine}`}}</span>
            <span class="peopleProfile__information--name" style="-webkit-box-orient: vertical;">{{highLightObject.userHighlight.name}}</span>
            <span class="peopleProfile__information--role" style="-webkit-box-orient: vertical;">{{highLightObject.userHighlight.role}}</span>
            <span class="peopleProfile__information--agency" style="-webkit-box-orient: vertical;">{{highLightObject.userHighlight.agency}}</span>
            <span class="peopleProfile__information--link" @click.stop="goToProfile(highLightObject.userHighlight.ecCode, 'ViewProfile')">VIEW PROFILE ></span>
          </div>
        </div>
        <div class="additional">
          <span class="additional__title">{{`${highLightObject.topLine} ${highLightObject.bottomLine}`}}</span>
          <span class="additional__descriptionTitle">{{highLightObject.descriptionTitle}}</span>
          <div class="additional__description">
            <span class="additional__description--text" v-html="highLightObject.description"></span>
            <div class="additional__description--tags">
              <span class="tagsText" v-for="(tag, index) in highLightTags" :key="index">{{tag}}</span>
            </div>
          </div>
        </div>
      </section>
      <section class="containerHighLightModalGeneric__content--post" v-else>
        <div class="background">
          <img class="backgroundImage" :src="highLightObject.imageUrl" />
        </div>
        <div class="participants" v-if="!isHighLightModalMobile">
          <div class="participants__header">
            <span class="participants__header--title">{{highLightObject.postHighlight.wantToSay}}</span>
            <span class="participants__header--agency" :title="highLightObject.postHighlight.agencies.join(', ')" style="-webkit-box-orient: vertical;">{{highLightObject.postHighlight.agencies.join(', ')}}</span>
          </div>
          <div class="participants__list">
            <span class="participants__list--participant" v-for="(participant, index) in highLightObject.postHighlight.participants" :key="index">
              <img class="image" :title="participant.name" @click.stop="goToProfile(participant.ecCode, 'ViewParticipant')" :src="setParticipantImage(participant)" />
            </span>
          </div>
        </div>
        <div class="participantsMobile" v-else>
          <span class="participantsMobile__title" style="-webkit-box-orient: vertical;">{{`${highLightObject.topLine} ${highLightObject.bottomLine}`}}</span>
          <span class="participantsMobile__toSay">{{highLightObject.postHighlight.wantToSay}}</span>
          <div class="participantsMobile__list">
            <span class="participantsMobile__list--participant" v-for="(participant, index) in highLightObject.postHighlight.participants" :key="index">
              <img class="image" :title="participant.name" @click.stop="goToProfile(participant.ecCode, 'ViewParticipant')" :src="setParticipantImage(participant)" />
            </span>
          </div>
          <span class="participantsMobile__agency" :title="highLightObject.postHighlight.agencies.join(', ')" style="-webkit-box-orient: vertical;">{{highLightObject.postHighlight.agencies.join(', ')}}</span>
        </div>
        <div class="additional">
          <span class="additional__title">{{`${highLightObject.topLine} ${highLightObject.bottomLine}`}}</span>
          <span class="additional__descriptionTitle">{{highLightObject.descriptionTitle}}</span>
          <div class="additional__description">
            <span class="additional__description--text" v-html="highLightObject.description"></span>
            <div class="additional__description--tags">
              <span class="tagsText" v-for="(tag, index) in highLightTags" :key="index">{{tag}}</span>
            </div>
          </div>
        </div>
      </section>
    </section>
    <div class="spinnerContainer" v-else>
      <spinnerGeneric class="spinnerContainer__spinner"></spinnerGeneric>
    </div>
  </modalGeneric>
</template>
<script>
import modalGeneric from '../modalGeneric/modalGeneric'
import spinnerGeneric from '../spinnerGeneric/spinnerGeneric'
import { ref, reactive, computed, onMounted, nextTick } from 'vue'
import { getHighlightInformation, saveAnalytics } from '../../../services'
import configEndPoints from '../../../config.json'

export default {
  name: 'highLightModalGeneric',
  components: {
    modalGeneric,
    spinnerGeneric
  },
  props: {
    highLightProp: {
      type: Object,
      default: () => {}
    },
    requestHighlight: {
      type: Boolean,
      default: false
    },
    highlightId: {
      type: String,
      default: ''
    },
    isHighLightModalMobile: {
      type: Boolean,
      required: true
    },
    application: {
      type: String,
      default: ''
    }
  },
  emits: ['close'],
  setup (props, { emit }) {
    const dataLoaded = ref(false)
    const highLightObject = ref({})
    const appConfig = reactive(configEndPoints)

    onMounted(() => {
      setHighLightInformation()
    })

    /**
     * @description Set highlight information
     */
    function setHighLightInformation () {
      if (props.requestHighlight) {
        getHighlightInformation(props.highlightId).then(
          (response) => {
            highLightObject.value = response.data
            dataLoaded.value = true
            nextTick(() => {
              setLinksInDescription()
            })
          }
        )
      } else {
        highLightObject.value = props.highLightProp
        dataLoaded.value = true
      }
    }

    /**
     * @description set highlight tags list
     */
    const highLightTags = computed(() => {
      const tagsWithHashtag = highLightObject.value.tags.map(tag => {
        return tag.charAt(0) === '#' ? tag : `#${tag}`
      })
      return tagsWithHashtag
    })

    /**
     * @description Set participan profile image
     */
    const setParticipantImage = computed(() => (participant) => {
      return participant.thumbnail ? participant.thumbnail : require('../../../assets/avatar.jpg')
    })

    /**
     * @description Closes the modal.
     */
    function close () {
      emit('close')
    }

    /**
     * @description Go to contact People profile
     * @param userId id of the user
     */
    function goToProfile (userId, analyticAction) {
      saveAnalytics(props.application, 'HighlightModal', analyticAction, highLightObject.value.id).then(() => {
        close()
        const baseUrl = `${appConfig.apps_url.people}/profile/${userId}`
        window.open(baseUrl, '_self')
      })
    }

    /**
     * @description sets onClick events for all the a tags in description
     */
    function setLinksInDescription () {
      const linkArray = document.querySelectorAll('.additional__description--text a')
      linkArray.forEach(el => {
        el.onclick = function () {
          close()
          window.open(el.href, '_self')
        }
        el.style.color = '#F54029'
        el.style.fontFamily = 'Roboto Bold'
      })
    }

    return {
      close,
      goToProfile,
      highLightTags,
      setParticipantImage,
      dataLoaded,
      highLightObject
    }
  }
}

</script>
